import { useEffect } from 'react';

const Ads = ({ slot }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Adsense error:", e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', width: '160px', height: '600px' }}
      data-ad-client="ca-pub-3690359022360146"
      data-ad-slot={slot}
      data-ad-format="vertical"
    />
  );
};

export default Ads;